import { BaseService } from '@colescba/services'
//import { authHeaders } from '@/util/auth.util'

class SolicitudesService extends BaseService {
  /**
   * Devuelve las solicitudes que cumplen con los criterios indicados
   *
   * @param {Object|Number} usuario
   * @param {Object} params
   * @param {String} params.desde
   * @param {String} params.hasta
   * @param {String} params.solicitudTipoId
   * @param {String} params.menorTipoDocumentoId
   * @param {String} params.menorNumeroDocumento
   * @param {String} params.menorApellidos
   * @param {String} params.menorNombres
   */
  async solicitudes(usuario, params) {
    const usuarioId = usuario.usuarioId || usuario
    params.usuarioId = usuarioId

    const response = await this.http.post(`/v2/solicitudes/search`, params)

    return response.data
  }

  /**
   * Devuelve la solicitud dado su id
   *
   * @param {Number} solicitudId
   */
  async solicitud(solicitudId) {
    const response = await this.http.get(`/v2/solicitudes/${solicitudId}`)

    return response.data
  }

  /**
   * Envía una notificación para el ID de solicitud especificado.
   *
   * @param {Number} solicitudId - El ID de la solicitud para enviar la notificación.
   * @param {Array<String>} emailsCC - Un arreglo de direcciones de correo electrónico que serán copiadas (CC) en la notificación.
   */

  async notificacion(solicitudId) {
    //const response = await this.http.post(`/solicitudes/${solicitudId}/notificacion`, params, { headers: authHeaders(" 20231744267")})
    const response = await this.http.post(`/solicitudes/${solicitudId}/notificacion`)
    return response
  }

  async notificacionVerificada(solicitudId) {
    //const response = await this.http.put(`/solicitudes/${solicitudId}/notificacion-verificada`,{}, { headers: authHeaders(" 20231744267")})
    const response = await this.http.put(`/solicitudes/${solicitudId}/notificacion-verificada`, {})
    return response
  }
}

export { SolicitudesService }
